import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { ModalModule } from "ngx-bootstrap";
import { LocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { HttpModule, JsonpModule } from '@angular/http';
import { AppConfig } from './app.config';
import { SharedModule } from './shared/shared.module';
import { LoadingModule } from 'ngx-loading';
// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]

// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';

//service
import { AuthenticationService } from './shared/services/authentication.service';
import { UserService } from './shared/services/user.service';
import { CityService } from './shared/services/city.service';
import { LeadService } from './shared/services/lead.service';
import { ActionService } from './shared/services/action.service';
import { RoleService } from './shared/services/role.service';
import { ProductService } from './shared/services/product.service';
import { AssignmentService } from './shared/services/assignment.service';
import { AdminDashboardService } from './shared/services/admin-dashboard.service';
import { DashboardService } from './shared/services/dashboard.service';
import { AreaManagementService } from './shared/services/area-management.service';
import { ProductSalesHistoryService } from './shared/services/product-sales-history.service';
import { PaymentCollectionService } from './shared/services/payment-collection.service';
import { PaymentDepositionService } from './shared/services/payment-deposition.service';
import { PermissionService } from './shared/services/permission.service';
import { ReportService } from './shared/services/report.service';
import { HolidayService } from './shared/services/holiday.service';
import { GoalService } from './shared/services/goal.service';
import { UploadService } from './shared/services/upload.service';
import { AdminReportService } from './shared/services/admin.report.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LeadNoticationDetailComponent } from './views/notification-detail/lead-notication-detail';
import { NotificationDetailModule } from './views/notification-detail/notification-detail.module';
import { AssignmentNotifiDetailComponent } from './views/notification-detail/assignment-notifi-detail';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ng6-toastr-notifications';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    JsonpModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    ChartsModule,
    LoadingModule,
    SharedModule,
    NgbModule.forRoot(),
    NotificationDetailModule,
    BrowserAnimationsModule, 
    ToastrModule.forRoot()
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
  ],
  providers: [{
    provide: APP_BASE_HREF,
    useValue: '/'
  }, AppConfig, AuthenticationService, UserService, CityService, LeadService, ActionService, RoleService,
    ProductService, AssignmentService, AreaManagementService,
    ProductSalesHistoryService, DashboardService,
    AdminDashboardService, PaymentCollectionService,
    PaymentDepositionService, PermissionService, ReportService,
    HolidayService, GoalService, UploadService, AdminReportService
  ],
  bootstrap: [AppComponent],
  entryComponents: [LeadNoticationDetailComponent, AssignmentNotifiDetailComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/app.module.ts